import script from "./sf-button-base.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-button-base.vue?vue&type=script&setup=true&lang=ts"

import "./sf-button-base.vue?vue&type=style&index=0&id=0c6b8244&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6b8244"]])

export default __exports__